import { AgriculturalMachine, Camper, Motorbike, VehicleTypes } from 'dealer-types'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

interface MainDescriptionProps {
  zipCode: string | null
  place: string | null
  countryCode: string | null
}

export const useMainDescription = ({ zipCode, place, countryCode }: MainDescriptionProps): string => {
  return useMemo(() => {
    return `${zipCode ?? '-'} | ${place ?? '-'} ${typeof countryCode === 'string' ? '|' : ''}`
  }, [countryCode, place, zipCode])
}

interface SecondaryDescriptionProps {
  vehicleType: VehicleTypes
  vehicle: Motorbike | Camper | AgriculturalMachine | undefined
}

export const useSecondaryDescription = ({ vehicleType, vehicle }: SecondaryDescriptionProps): string => {
  const { t } = useTranslation()

  return useMemo(() => {
    if (vehicleType === 'Motorbike') {
      const motorbike = vehicle as Motorbike
      return `${t('single_offer.date_of_first_registration')}: ${motorbike.year}`
    }
    if (vehicleType === 'Camper') {
      const camper = vehicle as Camper
      return `${t('single_offer.date_of_first_registration')}: ${camper.year}`
    }
    if (vehicleType === 'AgriculturalMachine') {
      const agriculturalMachine = vehicle as AgriculturalMachine
      return `${t('single_offer.year_of_production')}: ${agriculturalMachine.production_year}`
    }
    return ''
  }, [vehicleType, t, vehicle])
}
